import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
export default action('setImportance', datapoints.ComposeCommandSetImportance)(function setImportance(viewState, importance) {
    viewState.importance = importance;
});
//# sourceMappingURL=setImportance.js.map